import { GeneralError } from './GeneralError';

export class ComponentException extends GeneralError {}
